export default {
  props: {
    title: String,
    isOpen: {
      type: Boolean,
      default: false,
    },
    accordion: null,
    id: null,
  },
  data() {
    return {
      isOpenState: this.isOpen,
    };
  },
  computed: {
    isOpenModifier() {
      if (this.id) {
        this.isOpenState = (this.accordion === this.id);
      }
      return {
        'collapsible-panel--is-open': this.isOpenState,
      };
    },
  },
  methods: {
    toggle() {
      this.isOpenState = !this.isOpenState;
      if (this.id) {
        this.$emit('open', this.isOpenState ? this.id : null);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/collapsible-panel/components/collapsible-panel-simple/collapsible-panel-simple.js